import { useQuery } from "@tanstack/react-query";
import useAuthenticatedApiRequest from "../../AuthenticatedApiRequest";
import TchrURL from "../../TchrURL";

export interface Tool {
  id: number;
  priority: number;
  name: string;
  active: boolean;
  requiresLogin: boolean;
  usesCredits: boolean;
  isNew: boolean;
  isPilot: boolean;
  comingSoon?: boolean;
  topText: string;
  isLoading?: boolean;
}

export interface Feature extends Tool { }

export interface InitResponse {
  showWaitlistSignup: boolean;
  showRegistration: boolean;
  showLogin: boolean;
  tools: Tool[];
  isPilot: boolean;
  features: Feature[];
};

const useInit = () => {
  const { get } = useAuthenticatedApiRequest();

  return useQuery<InitResponse, Error, InitResponse>({
    queryKey: ["init"],
    queryFn: async () => {
      const url = new TchrURL("init");

      const response = await get(url);
      return response.json();
    },
  });
};

export default useInit;